import React, { useState, useEffect } from "react";

const GradoForm = ({ onSubmit, initialData, resetForm, maestros }) => {
    const [formData, setFormData] = useState({
        nombre_grado: "",
        maestro_id: "",
    });

    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        } else if (resetForm) {
            setFormData({
                nombre_grado: "",
                maestro_id: "",
            });
        }
    }, [initialData, resetForm]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Formulario de Grado</h2>
            <form onSubmit={handleSubmit} className="p-3 border rounded bg-light">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="nombre_grado" className="form-label">Nombre del Grado:</label>
                        <input
                            type="text"
                            id="nombre_grado"
                            name="nombre_grado"
                            className="form-control"
                            value={formData.nombre_grado}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="maestro_id" className="form-label">Maestro:</label>
                        <select
                            id="maestro_id"
                            name="maestro_id"
                            className="form-control"
                            value={formData.maestro_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un maestro</option>
                            {maestros.map((maestro) => (
                                <option key={maestro.usuario_id} value={maestro.usuario_id}>
                                    {maestro.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>);
};

export default GradoForm;